import SecureLS from "secure-ls";

let clientStorage;
const ClientStorage = async () => {
  const response = await window.axios.get("/v1/api/keys/client-storage");
  if (response?.data?.key) {
    clientStorage = new SecureLS({
      encodingType: "aes",
      isCompression: false,
      encryptionSecret: process.env.ENCRYPTION_SECRET
    });
  }

  return true;
};
export { clientStorage };
export default ClientStorage;
